import { createAsyncThunk } from '@reduxjs/toolkit';
import { LoanOfferApi, LoanOfferProgress } from 'api/LoanOfferApi';
import { LocalStorageKeyName } from 'enums/LocalStorageKeyName';
import RequestError from 'errors/RequestError';

import { ErrorResponse } from './ErrorResponse';

export const createUpdateLoanOfferThunk = (api: LoanOfferApi) =>
  createAsyncThunk(
    'loanOffer/updateLoanOffer',
    async (
      data: {
        applicationId: string;
        updateCallback?: (data: LoanOfferProgress) => void;
      },
      thunkApi,
    ) => {
      try {
        const { updateCallback, applicationId } = data;

        const loanOfferResult = await api.updateLoanOffer(applicationId, updateCallback);

        localStorage.setItem(LocalStorageKeyName.LoanOfferResult, JSON.stringify(loanOfferResult));

        return loanOfferResult;
      } catch (error: unknown) {
        if (error instanceof RequestError) {
          return thunkApi.rejectWithValue(error.toJson());
        }
        return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      }
    },
  );

export default createUpdateLoanOfferThunk;
